import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { CategorizationScheme } from '@aptitude/shared-vanilla';

@Injectable({
  providedIn: 'root',
})
export class CategorizationSchemesService {
  private _categorizationSchemes$ = new ReplaySubject<CategorizationScheme[]>(1);

  categorizationSchemes$ = this._categorizationSchemes$.asObservable();

  constructor() {}

  setCategorizationSchemes(schemes: CategorizationScheme[]) {
    this._categorizationSchemes$.next(schemes);
  }
}
